export { LocalizationFn as ɵLocalizationFn } from './lib/models/translation.model';
export { $localizer as ɵ$localizer } from './lib/utils/translate.function';
